import { FormControl } from '@angular/forms';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';

export enum POTICNewRequestAdditionalControlName {
  ConstructionPurpose = 'constructionPurpose',
}

export const POTICNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...POTICNewRequestAdditionalControlName,
};

export interface POTICNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [POTICNewRequestControlName.ConstructionPurpose]: FormControl<string>;
}
